import { urlForSpace } from "@src/utils/endpoints-urls";

/**
 * Base URL for welfare endpoints under a space
 */
export function urlForWelfare(spaceId: string): string {
  return `${urlForSpace(spaceId)}/welfare`;
}

/**
 * URL for fetching all welfare instances
 */
export function urlForWelfareInstances(spaceId: string): string {
  return urlForWelfare(spaceId);
}

/**
 * URL for fetching all welfare definitions
 */
export function urlForWelfareDefinitions(spaceId: string): string {
  return `${urlForWelfare(spaceId)}/definitions`;
}

export function urlForWelfareDefinitionDelete(
  spaceId: string,
  definitionId: string
): string {
  return `${urlForWelfareDefinitions(spaceId)}/${definitionId}`;
}

/**
 * URL for fetching occurrence policies for a given definition
 */
export function urlForWelfareOccurrencePolicies(spaceId: string, definitionId: string): string {
  return `${urlForWelfareDefinitions(spaceId)}/${definitionId}/occurrencePolicies`;
}

export function urlForWelfareOccurrencePolicy(
  spaceId: string,
  definitionId: string,
  policyId: string
): string {
  return `${urlForWelfareOccurrencePolicies(spaceId, definitionId)}/${policyId}`;
}

export function urlForGenerateWelfareInstances(spaceId: string): string {
  return `${urlForWelfare(spaceId)}/generate`;
}

export function urlForCancelWelfareInstance(
  spaceId: string,
  instanceId: string
): string {
  return `${urlForWelfareInstances(spaceId)}/instances/${instanceId}/cancel`;
}